export enum FileUploadError {
  MAX_FILE_SIZE_EXCEEDED = "maxFileSizeExceeded",
  INVALID_FILE_TYPE = "invalidFileType",
  NO_FILE_SELECTED = "noFileSelected",
  FILE_ALREADY_EXISTS = "fileAlreadyExists",
}
